export default function ToggleLabel({text, Icon}: {text: string; Icon: any}) {
  return (
    <span className="flex items-center whitespace-nowrap font-xs">
      <Icon className="h-4 w-4 mr-1" />
      {text}
    </span>
  )
}
